const $onePlusAccordions = $('.js-oneplus-join-accordion');
const ACTIVE_CLASS = 'is-active';

$onePlusAccordions.click((e) => {
  if (matchMedia('(min-width: 991px)').matches) {
    return;
  }

  const $clicked = $(e.currentTarget);
  const $accordion = $clicked.siblings('.js-accordion-content');

  $clicked.toggleClass(ACTIVE_CLASS);
  $accordion.toggleClass(ACTIVE_CLASS);
});
